import state from './moduleDeveloperModeState';
import getters from './moduleDeveloperModeGetters';
import mutations from './moduleDeveloperModeMutations';
import * as actions from './moduleDeveloperModeActions';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
